import { useResource } from "hooks/useResource";
import { getSettings } from "services/content";

/**
 * ConnectEd strip — deliberately minimal: a single login bar.
 * The login URL comes from admin → Settings → ConnectEd Portal.
 * When it isn't configured the button renders inert rather than as a live-
 * looking link that goes nowhere.
 */
export default function ConnectEdSection() {
  const { data: settings } = useResource(getSettings);
  const loginUrl = settings?.connectedUrl || "";

  return (
    <section className="px-4 sm:px-10 py-14 bg-green-dark relative overflow-hidden">
      <svg
        className="absolute inset-0 w-full h-full opacity-[0.04] pointer-events-none"
        viewBox="0 0 1200 600"
        preserveAspectRatio="xMidYMid slice"
      >
        {Array.from({ length: 6 }).map((_, r) =>
          Array.from({ length: 12 }).map((_, c) => (
            <circle key={`${r}-${c}`} cx={c * 110 + 55} cy={r * 110 + 55} r="32" fill="none" stroke="#fff" strokeWidth="1.5" />
          ))
        )}
      </svg>

      <div className="max-w-container mx-auto relative z-[2]">
        <div className="flex items-center justify-between bg-white/[0.06] border border-white/10 rounded-2xl px-6 sm:px-8 py-6 flex-wrap gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 rounded-[14px] bg-gradient-to-br from-[#00c87a] to-[#0066ff] flex items-center justify-center text-[22px] shrink-0">
              🎓
            </div>
            <div>
              <div className="text-white font-bold text-base">Access ConnectEd Portal</div>
              <div className="text-white/55 text-[13px]">
                Students, parents and teachers — log in to your dashboard
              </div>
            </div>
          </div>

          {loginUrl ? (
            <a
              href={loginUrl}
              target="_blank"
              rel="noreferrer"
              className="bg-gradient-to-br from-[#00c87a] to-[#009955] text-white no-underline rounded-[9px] px-8 py-3 font-sans font-bold text-sm inline-flex items-center transition-all duration-200 hover:-translate-y-0.5 hover:shadow-[0_8px_20px_rgba(0,200,122,0.3)]"
            >
              Login →
            </a>
          ) : (
            // No URL set in admin Settings yet — show it inert rather than as a
            // live-looking button that goes nowhere.
            <span
              title="Login URL not configured yet"
              className="bg-white/10 text-white/40 rounded-[9px] px-8 py-3 font-sans font-bold text-sm inline-flex items-center cursor-not-allowed"
            >
              Login →
            </span>
          )}
        </div>
      </div>
    </section>
  );
}
